import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { ImpressumComponent } from './components/pages/impressum/impressum.component';
import {DatenschutzComponent} from "./components/pages/datenschutz/datenschutz.component";
import {KlassenComponent} from "./components/pages/klassen/klassen.component";
import {KontaktComponent} from "./components/pages/kontakt/kontakt.component";
import {TeamComponent} from "./components/pages/team/team.component";
import {AboutComponent} from "./components/pages/about/about.component";
import {KurseComponent} from "./components/pages/kurse/kurse.component";
import {PreiseComponent} from "./components/pages/preise/preise.component";

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'about', component: AboutComponent},
    {path: 'klassen', component: KlassenComponent},
    {path: 'team', component: TeamComponent},
    {path: 'kurse', component: KurseComponent},
    {path: 'preise', component: PreiseComponent},
    {path: 'kontakt', component: KontaktComponent},
    {path: 'impressum', component: ImpressumComponent},
    {path: 'datenschutz', component: DatenschutzComponent},
    {path: '**', component: HomeOneComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
